const vimeoUrlParser = (url) => {
  const numbers = url.match(/\d+/g)
  const number = numbers.find((num) => String(num).length >= 8)
  return number
}

export default vimeoUrlParser
